/**
 * Orgao emissor do RG com a UF de emissao (pedido do user, 02/10: "por o local de
 * emissao obrigatorio"). A tela mostra dois campos, mas o valor segue num campo so'
 * ("SSP/GO"), o mesmo que o back e o contrato ja' usam: "RG nº 351636 SSP/GO".
 */
import { UF_SELECT_OPTIONS } from '../../../../constants/ufs';

// O gerador do contrato so' aceita 20 caracteres no orgao com a UF (a coluna do back tem 30).
export const ORGAO_COM_UF_MAX = 20;

const UFS = new Set(UF_SELECT_OPTIONS.map(o => o.value));

// UF no fim, depois de espaco, barra ou hifen: "SSP/GO", "SSP - GO", "MDEFESA DF".
const UF_NO_FIM = /^(.*?)[\s/\-–]+([A-Za-z]{2})\s*$/;

export const separarOrgaoEUf = (valor?: string | null): { orgao: string; uf: string } => {
  const texto = valor ?? '';
  const achado = UF_NO_FIM.exec(texto);
  if (achado && UFS.has(achado[2].toUpperCase())) {
    return { orgao: achado[1].trim(), uf: achado[2].toUpperCase() };
  }
  if (UFS.has(texto.trim().toUpperCase())) return { orgao: '', uf: texto.trim().toUpperCase() };
  return { orgao: texto, uf: '' };
};

// Sem `trim` aqui: e' chamado a cada tecla, e cortaria o espaco entre as palavras.
export const juntarOrgaoEUf = (orgao: string, uf: string): string =>
  uf ? `${orgao}/${uf}` : orgao;

export const temOrgaoEUf = (valor?: string | null): boolean => {
  const { orgao, uf } = separarOrgaoEUf(valor);
  return !!orgao.trim() && !!uf;
};

/** "SSP - GO" -> "SSP/GO". Sem orgao e UF reconheciveis, fica como veio. */
export const normalizarOrgaoEmissor = <T extends string | null | undefined>(
  valor: T,
): T | string => {
  if (!valor) return valor;
  const { orgao, uf } = separarOrgaoEUf(valor);
  return orgao.trim() && uf ? `${orgao.trim()}/${uf}` : valor;
};
